import type { TimeFilterConfiguration } from '@grandvisionhq/appointments'

const config: TimeFilterConfiguration = [
  {
    name: 'option1',
    from: '09:00',
    until: '12:00',
  },
  {
    name: 'option2',
    from: '12:00',
    until: '14:00',
  },
  {
    name: 'option3',
    from: '14:00',
    until: '18:00',
  },
  {
    name: 'option4',
    from: '18:00',
    until: '20:00',
  },
]

export const getTimeFiltersConfig = () => config
